export default __webpack_public_path__ + "static/media/cover1.e721a6ae.jpeg";